import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=6aefa6b8&scoped=true&lang=pug"
import script from "./TwoFactor.vue?vue&type=script&lang=js"
export * from "./TwoFactor.vue?vue&type=script&lang=js"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=6aefa6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefa6b8",
  null
  
)

export default component.exports